module.exports = {
    serverHost: "https://agentrepair-itsec.meituan.com",
    agentServerHost: "https://securityagent.sankuai.com",
    //线上(内网)
    //loginRediret:"https://ssosv.sankuai.com/sson/login?redirect_uri=https%3A%2F%2Fagent-repair-itsec.sankuai.com%2F%23%2Fcallback&client_id=2c4ad23224",
    //logoutRediret:"https://ssosv.sankuai.com/sson/logout?redirect_uri=https%3A%2F%2Fagent-repair-itsec.sankuai.com&client_id=2c4ad23224",
    //线上(外网)
    loginRedirect: "https://ssosv.sankuai.com/sson/login?redirect_uri=https%3A%2F%2Fagent-repair-prompt.sankuai.com%2F%23%2Fcallback&client_id=2c4ad23224",
    logoutRedirect: "https://ssosv.sankuai.com/sson/logout?redirect_uri=https%3A%2F%2Fagent-repair-prompt.sankuai.com&client_id=2c4ad23224"
};



// WEBPACK FOOTER //
// ./src/config/config.prod.js